document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-bt-gallery]').forEach(g=>{
    const thumbs=g.querySelectorAll('[data-bt-thumb]'),media=g.querySelectorAll('[data-bt-media]');
    thumbs.forEach(b=>b.addEventListener('click',()=>{
      const id=b.dataset.mediaId;
      thumbs.forEach(x=>x.classList.remove('is-active'));
      media.forEach(x=>x.classList.remove('is-active'));
      b.classList.add('is-active');
      const t=g.querySelector(`[data-bt-media][data-media-id="${id}"]`);
      if(t)t.classList.add('is-active');
    }));
  });
  document.querySelectorAll('[data-bt-variant-select]').forEach(s=>s.addEventListener('change',()=>{
    const o=s.options[s.selectedIndex],section=s.closest('[data-section-id]'),price=section?.querySelector('[data-bt-price]');
    if(price&&o.dataset.price)price.textContent=o.dataset.price;
  }));
});